module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8102/img/favicon-dark.png"